import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { GridOptions } from 'ag-grid-enterprise';
import { columns, ngcolumns, defaultColDef } from './scannerGridColDef';
// CSS
import 'ag-grid-enterprise/styles/ag-grid.css';
import 'ag-grid-enterprise/styles/ag-theme-balham.css';

interface GridProps {
  rowData: any[];
  onGridReady: (params: { api: any }) => void;
  handleDeleteRow: ( deleteId: string ) => void;
  isOkList: Boolean | null ;
}

// rowDataの管理はreduxを使うと、編集処理が遅くなるのでreduxを使わないことにした。
const Grid: React.FC<GridProps> = ({ rowData, onGridReady, handleDeleteRow, isOkList }) => {

  const gridOptions: GridOptions = {
    defaultColDef: defaultColDef,
    columnDefs: columns,
    suppressNoRowsOverlay: true,
  };

  const gridNgOptions: GridOptions = {
    defaultColDef: defaultColDef,
    columnDefs: ngcolumns,
    debounceVerticalScrollbar: true,
  };

  return (
    <div className="ag-theme-balham">
      { isOkList ? (
        <AgGridReact
          {...gridOptions}
          onGridReady={onGridReady}
          rowData={rowData}
          domLayout={"normal"} 
          onCellClicked={(params) => {
            if(params.column.getColId() === 'delbtn') {
              // ボタン押下時にrowDataから該当行を削除する
              handleDeleteRow(params.data.po_desc_num);
            };
          }}
        />) : (
        <AgGridReact
          {...gridNgOptions}
          onGridReady={onGridReady}
          rowData={rowData}
          domLayout={"normal"}
        />
        )}
    </div>
  );
};

export default Grid;